export const TemplateDraft: string = 'Template';
export const DistributionDraft: string = 'DistributionMessage';
export const OriginalMsgId: string = '-';
